'use strict';

const setAvailableTimeZones = (state, timeZones = []) => {
  state.availableTimeZones = timeZones;
};

const setDefaultTimeZone = (state, defaultTimeZone = []) => {
  state.defaultTimeZone = defaultTimeZone;
};

const setAvailableAgentStates = (state, states = []) => {
  state.availableAgentStates = states;
};

const setAvailableAgentCustomBreakStates = (state, states = []) => {
  state.availableCustomBreakStates = states;
};

const setValueSets = (state, valueSets = []) => {
  state.valueSets = valueSets;
};

const setSupervisorKPIsDescription = (state, supervisorKPIsDescription = []) => {
  state.supervisorKPIsDescription = supervisorKPIsDescription;
};

const addIncomingInteractionRingtone = (state, ringtone) => {
  state.availableIncomingInteractionRingtones.push(ringtone);
};

const setSmtpDetails = (state, smtpData) => {
  const { businessProcesses, defaultBccEmailAddress, defaultFromEmailAddress, outgoingEmailMode } = smtpData;
  state.smtpDetails.businessProcesses = [...businessProcesses];
  state.smtpDetails.defaultBccEmailAddress = defaultBccEmailAddress;
  state.smtpDetails.defaultFromEmailAddress = defaultFromEmailAddress;
  state.smtpDetails.outgoingEmailMode = outgoingEmailMode;
};

const setSmsDetails = (state, smsDetails) => {
  state.smsDetails = [...smsDetails];
};

export default {
  setAvailableTimeZones,
  setDefaultTimeZone,
  setAvailableAgentStates,
  setAvailableAgentCustomBreakStates,
  addIncomingInteractionRingtone,
  setSmtpDetails,
  setSmsDetails,
  setValueSets,
  setSupervisorKPIsDescription
};
